import http from '../jslibs/axios/http';
import dkAxiosFile from '@/jslibs/axios/axios-file';


//加入购物车
export const addCart = data => http.post('/mini/Cart', data);

//购物车
export const cart = data => http.get('/mini/Cart'+ data.chapter_uuid, data);

//删除购物车
export const delCart = data => http.delete('/mini/Cart/'+data.ids);
